var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorOctagon = function SvgErrorOctagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.5 14.036 14.036 5.5h21.929l8.535 8.536v21.929L35.965 44.5h-21.93L5.5 35.965zM13.828.5a4.5 4.5 0 0 0-3.182 1.318l-8.828 8.828A4.5 4.5 0 0 0 .5 13.828v22.344a4.5 4.5 0 0 0 1.318 3.182l8.828 8.828a4.5 4.5 0 0 0 3.182 1.318h22.344a4.5 4.5 0 0 0 3.182-1.318l8.828-8.828a4.5 4.5 0 0 0 1.318-3.182V13.828a4.5 4.5 0 0 0-1.318-3.182l-8.828-8.828A4.5 4.5 0 0 0 36.172.5zM25 12a2.5 2.5 0 0 1 2.5 2.5v11a2.5 2.5 0 0 1-5 0v-11A2.5 2.5 0 0 1 25 12m3 22.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
    clipRule: "evenodd"
  })));
};
export default SvgErrorOctagon;